import Vue from 'vue'
import Vuex from 'vuex'

import * as getters from './getters'
import * as actions from './actions'
import * as mutations from './mutations'

Vue.use(Vuex)

const state = {
  queryConfig: {
    type: "axios",
    url: "", // 变量
    method: "GET", // 变量
    data: null, // 变量
    header: {
      jwt: "",
      orgid: '',
      e: 1, // 是否加密，1 加密 0 不加密
    },
    timeout: 60000,
    interceptor_req: null,
    interceptor_res: null,
    orgid: '',
  }, // 请求配置
  voteInfo: null, // 投票信息
  jwt: "",
  orgid: "",
  voteText: "投票",
  activeTab: 0, // 投票组相关，用于切换标签时，传递给rank
  pageTrackingOptions: null // 页面埋点配置 
}

export default new Vuex.Store({
  state,
  getters,
  actions,
  mutations,
})
